module.exports = __webpack_public_path__ + "media/bookPage/header-102c3b79.jpg";